import { render } from "./OptionView.vue?vue&type=template&id=26065b12"
import script from "./OptionView.vue?vue&type=script&lang=js"
export * from "./OptionView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__